import { Component, OnDestroy, OnInit } from '@angular/core';
import { DocumentoTipo } from '../../../models/documento-tipo.model';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ActivatedRoute } from '@angular/router';
import { DocumentoTipoService } from '../../../services/documento-tipo.service';

@Component({
  selector: 'app-documento-tipo-list',
  templateUrl: './documento-tipo-list.component.html',
  styleUrls: ['./documento-tipo-list.component.scss']
})
export class DocumentoTipoListComponent 
extends BaseListComponent<DocumentoTipo> 
  implements OnInit, OnDestroy {

    documentoTipoList:DocumentoTipo[]; 

    constructor(
      private myService: DocumentoTipoService,
      public activatedRoute: ActivatedRoute
    ) {
      super();
    }
    
    ngOnInit() {
      this.initLoadDataTable();
    }
  
    ngOnDestroy(): void {
      this.unsubscribeList();
    }
    
    initLoadDataTable() {
      this.addSub(
        this.myService.findAll().subscribe((res) => {
          this.documentoTipoList = res;
          this.loaded();
        })
      );
    }

    novo() {
      return ['/pre-projeto/admin/documento-tipo/adicionar'];
    }
  
    editar(id: number) {
      return ['/pre-projeto/admin/documento-tipo/', id];
    }

}
